/**
 * @Author: Zewei
 * @Date:   2018-01-19T14:00:01+08:00
 * @Last modified by:
 * @Last modified time: 2018-01-22T12:33:27+08:00
 */

import React from 'react';
import { Link } from 'react-router-dom';
import Exception from '../../components/Exception';
// import LayoutWrapper from '../../layouts/LayoutWrapper.js';

export default () => (
  <Exception type="404" style={{ minHeight: 500, height: '80%' }} linkElement={Link} />
);



// WEBPACK FOOTER //
// ./src/routes/Exception/404.js